import api from '../../../api/_analyse'
// import api_resultat from '../../../api/_resultats-analyse'

export default {
    getAnalysesEnSalleAttente(data) {
        return new Promise((resolve, reject) => {
            api.getAnalysesEnSalleAttente(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListePatientAnalyseToFill(data) {
        return new Promise((resolve, reject) => {
            api.getListePatientAnalyseToFill(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getRegistreAnalyse(data) {
        return new Promise((resolve, reject) => {
            api.getRegistreAnalyse(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getDistinctAnalyse(data) {
        return new Promise((resolve, reject) => {
            api.getDistinctAnalyse(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getListeAnalyseByCategory(data) {
        return new Promise((resolve, reject) => {
            api.getListeAnalyseByCategory(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    saveResultatTDR(data) {
        return new Promise((resolve, reject) => {
            api.saveResultatTDR(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getBulletinAnalysesPatient(data) {
        return new Promise((resolve, reject) => {
            api.getBulletinAnalysesPatient(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getListePatientAttentePrelevement(data) {
        return new Promise((resolve, reject) => {
            api.getListePatientAttentePrelevement(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    savePrelevementsEffectues(data) {
        return new Promise((resolve, reject) => {
            api.savePrelevementsEffectues(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getResultatAnalysePatient(data) {
        return new Promise((resolve, reject) => {
            api.getResultatAnalysePatient(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}